import React from 'react';
import PropTypes from 'prop-types';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {
    isEmpty,
    extractWorkSheetData,
    getWithExpiry,
    formatDate,
    ExcelDateToDateString
} from "../../../globals/GlobalFunctions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from 'axios';
import {refreshToken} from "../../../globals/GlobalFunctions";
import Autocomplete from "@mui/material/Autocomplete";
import {GlobalConstants} from "../../../globals/GlobalConstants";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export interface Props {
    excelData: any;
    currentDB: string;
}

function BulkPlanYearPut({excelData, currentDB}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [validationError, setValidationError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [currentPlanYear, setCurrentPlanYear] = React.useState({group_ID: "",
        division_ID: "", from_Date: "", vbasoftware_database: "CoastalAdminTest", vbapi_Token: "", thru_Date: "", plan_Year: ""});

    let token = localStorage.getItem('jwt');

    const handleValidationClose = () => {
        setValidationError(false);
        setValidationText("");
    }

    const initialPlanYearState = { group_ID: "",
        division_ID: "",
        from_Date: "",
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",
        thru_Date: "",
        plan_Year: ""
    }

    const clearPlanYears = () => {
        setCurrentPlanYear({...initialPlanYearState});
    }

    const importPlanYears = async (planYearArray : any[]) => {
        refreshToken();
        setIsLoading(true);
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'GroupPlanYear/putList',
                    planYearArray,
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                    setIsLoading(false);
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                    setIsLoading(false);
                });
        //console.log(response);
    }

    try {
        //Check for data and that there is a sheet in the data named IDCodeValue
        if (!isEmpty(excelData) && excelData.Sheets.PlanYears !== undefined) {
            //console.log(excelData, "Made it to formatter!");

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.PlanYears);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            let planYearArray: any[] = [];

            //console.log(rawCellArray, "Raw Data");

            //we need to find the column index of the values we require so we can grab the data for each row -- THIS IS WHERE COLUMN NAMES ARE SET
            //we add 1 for each for the loop multiplier to account for it being zero based, but later we subtract 1 to account for the very fist row actually starting at zero
            const gpyIndexCollection = {

                groupIndex: rawCellArray.indexOf('Group ID') + 1,
                divisionIndex: rawCellArray.indexOf('Division ID') + 1,
                fromDateIndex: rawCellArray.indexOf('From Date') + 1,
                thruDateIndex: rawCellArray.indexOf('Thru Date') + 1,
                planYearIndex: rawCellArray.indexOf('Plan Year') + 1,
            }

            if(gpyIndexCollection.groupIndex > 0 && gpyIndexCollection.planYearIndex > 0 && gpyIndexCollection.fromDateIndex > 0 && gpyIndexCollection.thruDateIndex > 0) {

                for (let i = 1; i < rowRange; i++) {
                    //for each new array we skip over the previous records determined by the column length, removing 1 to account for our zero based index at the beginning
                    let rowMultiplier = columnRange * i - 1;

                    //start with group
                    if (gpyIndexCollection.groupIndex > 0) {
                        currentPlanYear.group_ID = rawCellArray[(rowMultiplier + gpyIndexCollection.groupIndex)].toString();
                    }

                    //division
                    if (gpyIndexCollection.divisionIndex > 0) {
                        currentPlanYear.division_ID = rawCellArray[(rowMultiplier + gpyIndexCollection.divisionIndex)].toString();
                    }

                    //plan year
                    if (gpyIndexCollection.planYearIndex > 0 && rawCellArray[(rowMultiplier + gpyIndexCollection.planYearIndex)].toString().length > 0) {
                        currentPlanYear.plan_Year = rawCellArray[(rowMultiplier + gpyIndexCollection.planYearIndex)].toString();
                    }

                    //from Date
                    if (gpyIndexCollection.fromDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + gpyIndexCollection.fromDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentPlanYear.from_Date = date.toString().toUpperCase();
                    }

                    //thru Date
                    if (gpyIndexCollection.thruDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + gpyIndexCollection.thruDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.includes("-")) {
                            date = date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4);
                        }
                        else if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        currentPlanYear.thru_Date = date.toString().toUpperCase();
                    }

                    currentPlanYear.vbasoftware_database = currentDB;

                    currentPlanYear.vbapi_Token = getWithExpiry('vbapi_Token');

                    if(currentPlanYear.group_ID.length > 0 && currentPlanYear.plan_Year.length > 0
                        && currentPlanYear.from_Date.length > 0 && currentPlanYear.thru_Date.length > 0) {
                        planYearArray.push({...currentPlanYear});
                    }

                    currentPlanYear.plan_Year = initialPlanYearState.plan_Year;
                    currentPlanYear.from_Date = initialPlanYearState.from_Date;
                    currentPlanYear.division_ID = initialPlanYearState.division_ID;
                    currentPlanYear.thru_Date = initialPlanYearState.thru_Date;
                    currentPlanYear.group_ID = initialPlanYearState.group_ID;

                    clearPlanYears();
                }

                importPlanYears(planYearArray);

                excelData.Sheets.PlanYears = undefined;
            }
            else {
                //setValidationText("Group ID, Plan ID, and Vendor are required.");
                //setValidationError(true);
            }

        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.PlanYears = undefined;
    }

    return (
        <div>
            {successAlert ? <Alert className="groupAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Plan Year Import Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert className="groupAlertStyles" severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default React.memo(BulkPlanYearPut)

BulkPlanYearPut.propTypes = {
    excelData: PropTypes.object.isRequired
};
